import React, { useCallback, useMemo } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import Toast from 'react-native-root-toast';

import MachineSetupCreator from './MachineSetupCreator';
import { EmptyState, Screen } from '../../../design/components';
import { CREATE_MACHINE_SETUP } from '../../../../common/graphql/machineSetup';

const MachineSetupCreatorView = () => {
	const navigation = useNavigation();
	const route = useRoute();
	const locationSetup = route.params?.locationSetup;

	const initialValues = useMemo(() => {
		if (!locationSetup) {
			return null;
		}
		return {
			locationSetup,
			place: null,
			machine: null,
			planogram: null,
			requiresCreditCardReader: true,
			requiresCashPayments: false,
			assignees: [],
			placePhotos: [],
			additionalInstructions: '',
		};
	}, [locationSetup]);

	const validation = useCallback(values => [
		{ field: 'placePhotos', error: 'Add at least one photo of the site', rule: values.placePhotos.length },
	], []);

	const handleSuccess = useCallback((newSetup) => {
		Toast.show('Machine setup created');
		navigation.replace('MachineSetupDetailView', { machineSetupId: newSetup.id });
	}, [navigation]);

	if (!locationSetup || !initialValues) {
		return (
			<Screen>
				<EmptyState title="Unable to start machine setup creator without a location setup." />
			</Screen>
		);
	}

	return (
		<MachineSetupCreator
			createMutation={CREATE_MACHINE_SETUP}
			initialValues={initialValues}
			locationSetup={locationSetup}
			onSubmitSuccess={handleSuccess}
			validation={validation}
		/>
	);
};

export default MachineSetupCreatorView;
